import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

export const StyledCircularProgress = styled(CircularProgress)`
  margin-top: 3vh;
`;
